/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AiFunctionRenderTemplateRequestDto } from '../models/ai-function-render-template-request-dto';
import { AiFunctionCall } from '../models/ai-function-call';
import { AiFunctionCallOptionalResponseJsonSampleSystemPromptFunctionPromptExcludingProjectIdCopyToNewProjects } from '../models/ai-function-call-optional-response-json-sample-system-prompt-function-prompt-excluding-project-id-copy-to-new-projects';
import { AiFunctionCallWithRelations } from '../models/ai-function-call-with-relations';
import { AnalyzeDataSourceRequestDto } from '../models/analyze-data-source-request-dto';
import { MilvusSearchByAiResponseDto } from '../models/milvus-search-by-ai-response-dto';
import { MilvusSearchRequestDto } from '../models/milvus-search-request-dto';
import { NewAiFunctionCall } from '../models/new-ai-function-call';
import { OpenAiRequestDto } from '../models/open-ai-request-dto';
import { OpenAiTabularDataSourceSearchRequestDto } from '../models/open-ai-tabular-data-source-search-request-dto';
import { OpenAiTabularDataSourceSearchResponseDto } from '../models/open-ai-tabular-data-source-search-response-dto';

@Injectable({
  providedIn: 'root',
})
export class AiFunctionCallControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation aiFunctionCallControllerAnalyzeDataSource
   */
  static readonly AiFunctionCallControllerAnalyzeDataSourcePath = '/ai-function-calls/data-source-analyze';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `analyzeDataSource()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  analyzeDataSource$Response(params?: {
    body?: AnalyzeDataSourceRequestDto
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, AiFunctionCallControllerService.AiFunctionCallControllerAnalyzeDataSourcePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `analyzeDataSource$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  analyzeDataSource(params?: {
    body?: AnalyzeDataSourceRequestDto
  }): Observable<any> {

    return this.analyzeDataSource$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation aiFunctionCallControllerExecuteFunctionToolsCall
   */
  static readonly AiFunctionCallControllerExecuteFunctionToolsCallPath = '/ai-function-calls/execute-function-tools-call/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `executeFunctionToolsCall$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  executeFunctionToolsCall$FormData$Response(params: {
    id: string;
    body?: {  }
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, AiFunctionCallControllerService.AiFunctionCallControllerExecuteFunctionToolsCallPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `executeFunctionToolsCall$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  executeFunctionToolsCall$FormData(params: {
    id: string;
    body?: {  }
  }): Observable<any> {

    return this.executeFunctionToolsCall$FormData$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `executeFunctionToolsCall$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  executeFunctionToolsCall$Json$Response(params: {
    id: string;
    body?: any
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, AiFunctionCallControllerService.AiFunctionCallControllerExecuteFunctionToolsCallPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `executeFunctionToolsCall$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  executeFunctionToolsCall$Json(params: {
    id: string;
    body?: any
  }): Observable<any> {

    return this.executeFunctionToolsCall$Json$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation aiFunctionCallControllerGenerateByAi
   */
  static readonly AiFunctionCallControllerGenerateByAiPath = '/ai-function-calls/generate-by-ai';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `generateByAI()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  generateByAI$Response(params?: {

    /**
     * AI Function request payload
     */
    body?: OpenAiRequestDto
  }): Observable<StrictHttpResponse<AiFunctionCall>> {

    const rb = new RequestBuilder(this.rootUrl, AiFunctionCallControllerService.AiFunctionCallControllerGenerateByAiPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AiFunctionCall>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `generateByAI$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  generateByAI(params?: {

    /**
     * AI Function request payload
     */
    body?: OpenAiRequestDto
  }): Observable<AiFunctionCall> {

    return this.generateByAI$Response(params).pipe(
      map((r: StrictHttpResponse<AiFunctionCall>) => r.body as AiFunctionCall)
    );
  }

  /**
   * Path part for operation aiFunctionCallControllerTabularDatasourceSearch
   */
  static readonly AiFunctionCallControllerTabularDatasourceSearchPath = '/ai-function-calls/tabular-datasource-search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tabularDatasourceSearch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tabularDatasourceSearch$Response(params?: {
    body?: OpenAiTabularDataSourceSearchRequestDto
  }): Observable<StrictHttpResponse<OpenAiTabularDataSourceSearchResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, AiFunctionCallControllerService.AiFunctionCallControllerTabularDatasourceSearchPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OpenAiTabularDataSourceSearchResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `tabularDatasourceSearch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tabularDatasourceSearch(params?: {
    body?: OpenAiTabularDataSourceSearchRequestDto
  }): Observable<OpenAiTabularDataSourceSearchResponseDto> {

    return this.tabularDatasourceSearch$Response(params).pipe(
      map((r: StrictHttpResponse<OpenAiTabularDataSourceSearchResponseDto>) => r.body as OpenAiTabularDataSourceSearchResponseDto)
    );
  }

  /**
   * Path part for operation aiFunctionCallControllerRenderTemplate
   */
  static readonly AiFunctionCallControllerRenderTemplatePath = '/ai-function-calls/template-render';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `renderTemplate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  renderTemplate$Response(params?: {
    body?: AiFunctionRenderTemplateRequestDto
  }): Observable<StrictHttpResponse<Array<AiFunctionCallWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, AiFunctionCallControllerService.AiFunctionCallControllerRenderTemplatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AiFunctionCallWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `renderTemplate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  renderTemplate(params?: {
    body?: AiFunctionRenderTemplateRequestDto
  }): Observable<Array<AiFunctionCallWithRelations>> {

    return this.renderTemplate$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AiFunctionCallWithRelations>>) => r.body as Array<AiFunctionCallWithRelations>)
    );
  }

  /**
   * Path part for operation aiFunctionCallControllerVectorSearch
   */
  static readonly AiFunctionCallControllerVectorSearchPath = '/ai-function-calls/vector-search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vectorSearch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vectorSearch$Response(params?: {
    body?: MilvusSearchRequestDto
  }): Observable<StrictHttpResponse<MilvusSearchByAiResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, AiFunctionCallControllerService.AiFunctionCallControllerVectorSearchPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MilvusSearchByAiResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `vectorSearch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vectorSearch(params?: {
    body?: MilvusSearchRequestDto
  }): Observable<MilvusSearchByAiResponseDto> {

    return this.vectorSearch$Response(params).pipe(
      map((r: StrictHttpResponse<MilvusSearchByAiResponseDto>) => r.body as MilvusSearchByAiResponseDto)
    );
  }

  /**
   * Path part for operation aiFunctionCallControllerUpdateAiFunctionCallByAi
   */
  static readonly AiFunctionCallControllerUpdateAiFunctionCallByAiPath = '/ai-function-calls/{id}/by-ai';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAIFunctionCallByAI()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAIFunctionCallByAI$Response(params: {
    id: string;
    body?: OpenAiRequestDto
  }): Observable<StrictHttpResponse<Array<AiFunctionCallWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, AiFunctionCallControllerService.AiFunctionCallControllerUpdateAiFunctionCallByAiPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AiFunctionCallWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateAIFunctionCallByAI$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAIFunctionCallByAI(params: {
    id: string;
    body?: OpenAiRequestDto
  }): Observable<Array<AiFunctionCallWithRelations>> {

    return this.updateAIFunctionCallByAI$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AiFunctionCallWithRelations>>) => r.body as Array<AiFunctionCallWithRelations>)
    );
  }

  /**
   * Path part for operation aiFunctionCallControllerFindById
   */
  static readonly AiFunctionCallControllerFindByIdPath = '/ai-function-calls/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<AiFunctionCallWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, AiFunctionCallControllerService.AiFunctionCallControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AiFunctionCallWithRelations>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: string;
    filter?: any;
  }): Observable<AiFunctionCallWithRelations> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<AiFunctionCallWithRelations>) => r.body as AiFunctionCallWithRelations)
    );
  }

  /**
   * Path part for operation aiFunctionCallControllerDeleteById
   */
  static readonly AiFunctionCallControllerDeleteByIdPath = '/ai-function-calls/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, AiFunctionCallControllerService.AiFunctionCallControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    id: string;
  }): Observable<any> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation aiFunctionCallControllerUpdateById
   */
  static readonly AiFunctionCallControllerUpdateByIdPath = '/ai-function-calls/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    id: string;
    body?: AiFunctionCallOptionalResponseJsonSampleSystemPromptFunctionPromptExcludingProjectIdCopyToNewProjects
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, AiFunctionCallControllerService.AiFunctionCallControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    id: string;
    body?: AiFunctionCallOptionalResponseJsonSampleSystemPromptFunctionPromptExcludingProjectIdCopyToNewProjects
  }): Observable<any> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation aiFunctionCallControllerFind
   */
  static readonly AiFunctionCallControllerFindPath = '/ai-function-calls';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<Array<AiFunctionCallWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, AiFunctionCallControllerService.AiFunctionCallControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AiFunctionCallWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
  }): Observable<Array<AiFunctionCallWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AiFunctionCallWithRelations>>) => r.body as Array<AiFunctionCallWithRelations>)
    );
  }

  /**
   * Path part for operation aiFunctionCallControllerCreate
   */
  static readonly AiFunctionCallControllerCreatePath = '/ai-function-calls';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  create$FormData$Response(params?: {
    body?: {  }
  }): Observable<StrictHttpResponse<AiFunctionCall>> {

    const rb = new RequestBuilder(this.rootUrl, AiFunctionCallControllerService.AiFunctionCallControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AiFunctionCall>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  create$FormData(params?: {
    body?: {  }
  }): Observable<AiFunctionCall> {

    return this.create$FormData$Response(params).pipe(
      map((r: StrictHttpResponse<AiFunctionCall>) => r.body as AiFunctionCall)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Json$Response(params?: {
    body?: NewAiFunctionCall
  }): Observable<StrictHttpResponse<AiFunctionCall>> {

    const rb = new RequestBuilder(this.rootUrl, AiFunctionCallControllerService.AiFunctionCallControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AiFunctionCall>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Json(params?: {
    body?: NewAiFunctionCall
  }): Observable<AiFunctionCall> {

    return this.create$Json$Response(params).pipe(
      map((r: StrictHttpResponse<AiFunctionCall>) => r.body as AiFunctionCall)
    );
  }

}
